/**
 * Shared label/badge mappers — keep clinical/operational status as color + glyph + text (never color
 * alone). Badge tones come from the UI kit; priority/statut copy comes from the i18n namespace.
 */
import { Badge } from "@/ui";
import { useT } from "@/app";
import type { Priorite, TicketStatut } from "../types";

/** Statut -> Badge tone. Operational (not clinical) tones; text always accompanies. */
const STATUT_TONE: Record<TicketStatut, "neutral" | "info" | "warn" | "success" | "danger"> = {
  en_attente: "neutral",
  appele: "info",
  absent: "warn",
  preleve: "success",
  achemine: "info",
  termine: "success",
  annule: "danger",
};

export function StatutBadge({ statut }: { statut: TicketStatut }) {
  const { t } = useT();
  return <Badge tone={STATUT_TONE[statut] ?? "neutral"}>{t(`sampling.statut.${statut}`)}</Badge>;
}

export function PrioriteBadge({ priorite }: { priorite: Priorite }) {
  const { t } = useT();
  // Urgent uses the "high" clinical tone so it carries the mandated ↑ glyph (shape, not color alone).
  if (priorite === "urgent") return <Badge tone="high">{t("sampling.priorite.urgent")}</Badge>;
  return <Badge tone="neutral">{t("sampling.priorite.routine")}</Badge>;
}
